import type { GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200 } from '@fukuri-admins/apis/client/gen/model';
import type { EditUserFormFieldValues } from '../schema';

type IConvertToFormValues = (
  data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200
) => EditUserFormFieldValues;

/**
 * API レスポンスを利用者編集フォームの初期値に変換する
 *
 * - billable_from（'YYYY-MM-DD' 文字列）は Date に変換（DatePicker 用）
 * - phoneNumber は電話番号フィールド非表示のテナント（login_method='email' 等）では
 *   Presentation 側で非表示になるが、フォーム値としては常にセットしておく
 *
 * @param data - GET /partner_admins/users/:userId のレスポンス
 * @returns useForm の defaultValues に渡す値
 */
export const convertToFormValues: IConvertToFormValues = data => ({
  fullName: data.user.full_name,
  email: data.user.email ?? '',
  phoneNumber: data.user.phone_number ?? '',
  externalUserId: data.user.external_user_id ?? '',
  password: '',
  passwordConfirmation: '',
  billableFrom: data.user.billable_from ? new Date(data.user.billable_from) : null,
});
